import "./css/style.scss";
import ReactDOM from "react-dom/client";
import NavBar from "./Components/NavBar.jsx";
import Footer from "./Components/Footer.jsx";
// import Home from "./Home.jsx";
import Projects from "./Projects.jsx";
import { content } from "./content.js";

export default function App() {
  const scroll = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <div className="main">
        <NavBar content={content.navbar} handleScroll={scroll} />
        {/* <Home
        content={content.home}
        goDown={() => {
          scroll("projects");
        }}
      /> */}
        <Projects content={content.projects} />
      </div>
      <Footer id="footer" content={content.footer} />
    </>
  );
}
